<template>
  <picture :class="imgId" v-html="innerHTML"></picture>
</template>

<script>
import { toRefs, ref } from "vue";
export default {
  props: {
    imgId: String,
    imgType: String,
    imgAlt: String,
  },
  setup(props) {
    const { imgId, imgType, imgAlt } = toRefs(props);
    const imageHost = "https://res.cloudinary.com/dyubvu51u/image/upload/";
    const cloudName = "v1602847784";
    const folder = "OIJV";
    const innerHTML = ref("");

    createImage();

    function createImage() {
      const imgInfo = getImageInfoByType(imgType.value);
      const picture = document.createElement("picture");
      imgInfo.extensions. map(function (extention) {
        return imgInfo.sizes.map((size) => {
          const source = picture.appendChild(document.createElement("source"));
          source.type = "image/" + extention;
          source.media = size.media;
          source.srcset = size.srcset
            .map((width) => {
              return `${imageHost}q_${size.quality},c_fill,w_${width}${
                size.ratio
                  ? ",h_" +
                    Math.round((size.ratio.height / size.ratio.width) * width)
                  : ""
              }/${cloudName}/${folder}/${imgId.value}.${extention} ${width}w`;
            })
            .join(", ");
          source.sizes = size.sizes;
        });
      });
      const img = picture.appendChild(document.createElement("img"));
      if (imgInfo.fallback) {
        img.src = `${imageHost}q_${imgInfo.fallback.quality},c_fill,w_${
          imgInfo.fallback.width
        }${
          imgInfo.fallback.ratio
            ? ",h_" +
              Math.round(
                (imgInfo.fallback.ratio.height / imgInfo.fallback.ratio.width) *
                  imgInfo.fallback.width
              )
            : ""
        }/${cloudName}/${folder}/${imgId.value}.jpg`;
      } else {
        img.src = `${imageHost}q_80,c_fill,w_900/${cloudName}/${folder}/${imgId.value}.jpg`;
      }

      img.setAttribute("alt", imgAlt.value);
      img.setAttribute("loading", "lazy");

      innerHTML.value = picture.innerHTML;
    }
    return {
      innerHTML,
    };
  },
};
function getImageInfoByType(type) {
  switch (type) {
    case "heroImg":
      return {
        extensions: ["webp", "wdp", "jp2", "jpg"],
        sizes: [
          {
            ratio: {
              width: 9,
              height: 12,
            },
            media: "(max-width: 799px)",
            srcset: [400, 500, 600, 700, 800, 900, 1000],
            sizes: "100vw",
            quality: 60,
          },
          {
            ratio: {
              width: 5,
              height: 4,
            },
            media: "(min-width: 800px)",
            srcset: [
              1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900,
            ],
            sizes: "100vw",
            quality: 60,
          },
        ],
        fallback: {
          ratio: {
            width: 5,
            height: 4,
          },
          width: 1600,
          quality: 80,
        },
      };
    case "imagepopup-img":
      return {
        extensions: ["webp", "wdp", "jp2", "jpg"],
        sizes: [
          {
            ratio: {
              width: 4,
              height: 3,
            },
            media: "",
            srcset: [400, 500, 600, 700, 800, 900, 1000, 1100, 1200],
            sizes: "(min-width: 77rem) 75rem, calc(100vw - 2rem)",
            quality: 50,
          },
        ],
        fallback: {
          width: 800,
          quality: 50,
        },
      };
    case "logo-img":
      return {
        extensions: ["webp", "png"],
        sizes: [
          {
            media: "",
            srcset: [400, 500, 600, 700, 800, 900, 1000],
            sizes: "(min-width: 77rem) 50vw, 400px",
            quality: 60,
          },
        ],
        fallback: {
          width: 900,
          quality: 80,
        },
      };
    case "collage-100":
      return {
        extensions: ["webp", "wdp", "jp2", "jpg"],
        sizes: [
          {
            media: "",
            srcset: [400, 500, 600, 700, 800, 900, 1000, 1100, 1200],
            sizes: "(min-width: 80rem) 80rem, calc(100vw - 2rem)",
            quality: 50,
          },
        ],
        fallback: {
          width: 800,
          quality: 40,
        },
      };
    case "collage-50":
      return {
        extensions: ["webp", "wdp", "jp2", "jpg"],
        sizes: [
          {
            media: "(max-width: 799px)",
            srcset: [500, 600, 700, 800, 900, 1000, 1100],
            sizes: "calc(100vw - 2rem)",
            quality: 40,
          },
          {
            media: "(min-width: 800px)",
            srcset: [300, 400, 500, 600],
            sizes: "(max-width: 77rem) calc(100vw / 2 - 1rem)",
            quality: 40,
          },
        ],
        fallback: {
          width: 800,
          quality: 40,
        },
      };
    case "collage-17":
      return {
        extensions: ["webp", "wdp", "jp2", "jpg"],
        sizes: [
          {
            ratio: {
              width: 1,
              height: 1,
            },
            media: "(max-width: 799px)",
            srcset: [300, 400, 500, 600, 700, 800],
            sizes: "calc(100vw / 2 - 1rem)",
            quality: 40,
          },
          {
            ratio: {
              width: 1,
              height: 1,
            },
            media: "(min-width: 800px)",
            srcset: [200, 250, 300],
            sizes: "18rem",
            quality: 40,
          },
        ],
        fallback: {
          width: 800,
          quality: 50,
        },
      };
    case "newsThumbnail": {
      return {
        extensions: ["webp", "wdp", "jp2", "jpg"],
        sizes: [
          {
            ratio: {
              width: 4,
              height: 3,
            },
            media: "(max-width: 799px)",
            srcset: [300, 400, 500, 600],
            sizes: "calc(100vw - 2rem)",
            quality: 40,
          },
          {
            ratio: {
              width: 16,
              height: 9,
            },
            media: "(min-width: 800px)",
            srcset: [400, 500, 600],
            sizes: "calc(80rem / 2 - 1rem);",
            quality: 40,
          },
        ],
        fallback: {
          width: 500,
          quality: 50,
        },
      };
    }
    case "newsImage": {
      return {
        extensions: ["webp", "wdp", "jp2", "jpg"],
        sizes: [
          {
            ratio: {
              width: 16,
              height: 9,
            },
            media: "",
            srcset: [400, 500, 600, 700, 800, 900, 1000, 1100, 1200],
            sizes: "(min-width: 80rem) 80rem, calc(100vw - 2rem)",
            quality: 50,
          },
        ],
        fallback: {
          width: 800,
          quality: 40,
        },
      };
    }
    case "imagemanager_thumbnail": {
      return {
        extensions: ["webp", "wdp", "jp2", "jpg"],
        sizes: [
          {
            ratio: {
              width: 4,
              height: 3,
            },
            media: "(max-width: 799px)",
            srcset: [300, 400, 500, 600],
            sizes: "calc(100vw - 2rem)",
            quality: 40,
          },
          {
            ratio: {
              width: 16,
              height: 9,
            },
            media: "(min-width: 800px)",
            srcset: [400, 500, 600],
            sizes: "calc(80rem / 2 - 1rem);",
            quality: 40,
          }
        ],
        fallback: {
          width: 250,
          quality: 40,
        },
      };
    }
  }
}
</script>